import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import FontIcon from 'components/icons';

import './styles/faq.scss';
import './styles/accordion.scss';

type Props = {
  faq: Faq[];
};

type Faq = {
  answer: string;
  question: string;
};

const Faqs = ({ faq }:Props) => {
  return (
    <Accordion className="accordion box faq-accordion">
      <h2 className="title is-size-4 has-text-centered">
        Frequently Asked Questions
      </h2>
      {faq.map((dialogue, index) => {
        return (
          <AccordionItem key={ index }>
            <AccordionItemHeading>
              <AccordionItemButton>
                <div className="btn-focus" tabIndex={ -1 }>
                  <h3 className="is-size-6">
                    {dialogue.question}
                    <FontIcon icon="chevron-up" />
                  </h3>
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p
                className="fadein is-size-6"
                dangerouslySetInnerHTML={ { __html: dialogue.answer } }
              />
            </AccordionItemPanel>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

export default Faqs;
